export default __webpack_public_path__ + "static/media/63.2696526e.jpg";